import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>MLS Data Services - Elm Street</title>
        <meta
          name="description"
          content="Elm Street's customizable agent and property data delivery solutions offer an all-in-one solution to streamline data management and offer flexible, custom delivery."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/mls_data_services" />
        <meta property="og:title" content="MLS Data Services - Elm Street" />
        <meta
          property="og:description"
          content="Elm Street's customizable agent and property data delivery solutions offer an all-in-one solution to streamline data management and offer flexible, custom delivery."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('mls2bg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street - MLS Data Services"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    MLS Data
                    <br />
                    <span style={{ color: mainTheme.palette.secondary.main }}>services</span>
                  </Typography>
                  <p>
                    Comprehensive Data for Much
                    <br />
                    of the U.S. and Canada
                  </p>

                  <Button variant="contained" color="secondary" href="#form">
                    request information
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div
          style={{
            marginTop: "75px",
            marginBottom: "75px",
            textAlign: "center",
          }}
        >
          <Grid container spacing={8}>
            <Grid item md={12} sm={12}>
              Elm Street's customizable agent and property data delivery solutions offer an all-in-one solution to
              streamline data management and offer flexible, custom delivery.
              <br />
              <br />
              <Button variant="contained" color="secondary" href="/markets">
                explore mls markets
              </Button>
            </Grid>
          </Grid>
        </div>
      </Container>

      <div
        style={{
          backgroundColor: "#f7f7f7",
          paddingTop: "65px",
          paddingBottom: "65px",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            textAlign: "center",
          }}
        >
          <div>
            <Image src="/es_map.svg" width="950px" height="950px" alt="Elm Street - MLS Data Services Map" />
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              request information
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>Connect with our team to explore your unique needs.</strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      listId="147992"
                      successUrl="thankyou-simplified"
                      formName="es2_mls_data"
                      fieldList={["first_name", "last_name", "email", "phone", "roll", "needs"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
